import {ActionService, ConfigurationService, JwtHttpClientService, ResourceModule} from "@fedeltapointofsale/data-client";
import {Inject, Injectable} from "@angular/core";

export class SalesJournalVoidAction {
    constructor(public receiptNo: string) {
    }
}

export class SalesJournalVoidSaleAction {
    constructor(public receiptNo: string, public adjustStock: boolean) {
    }
}

/**
 * Action Service to void a sale
 */
@Injectable()
export class SalesJournalVoidSaleService extends ActionService {
    constructor(http: JwtHttpClientService,
                configService: ConfigurationService,
                @Inject(ResourceModule.RESOURCE_NAMESPACE_KEY) nameSpace,
                @Inject(ResourceModule.ACTION_NAMES_KEY) actionNames) {
        super(http, configService, nameSpace, actionNames, "sales-journal-void-sale");
    }
}
